module.exports = __webpack_public_path__ + "static/media/googlePlay.81a3ede7.png";